import { RouteType } from "types/RouteType";
import EquipmentMaintenanceWizardStore from "./EquipmentMaintenanceWizardStore";

const EquipmentMaintenanceWizardRoute: RouteType = {
  name: "EquipmentMaintenanceWizard",
  path: "/workflows/equipment-maintenance",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Equipment Maintenance",
      component: () => import("./EquipmentMaintenanceWizardHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./EquipmentMaintenanceWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.equipmentMaintenanceWizardStore) {
      rootStore.equipmentMaintenanceWizardStore = new EquipmentMaintenanceWizardStore(
        rootStore
      );
    }
    await rootStore.equipmentMaintenanceWizardStore.loadInitialData();
    return true;
  },
};

export default EquipmentMaintenanceWizardRoute;